import { css } from "@emotion/react"
import styled from "@emotion/styled"

import Image from "components/media/ImageCLD"
import { fullGrid } from "css/grid"

import FigCaption, { fullWidthInnerStyle, isInnerCN } from "components/figcaption/FigCaption"

const pseudoStyles = css`
  content: "";
  display: block;
  position: absolute;
  left: 0;
  width: 100%;
  height: 20vh;
  z-index: 0;
`

const Root = styled.figure`
  --hh: 100vh;
  display: grid;
  position: relative;
  height: calc(var(--hh) * 2);
  margin-block-start: calc(var(--hh) * -1);
  z-index: -3;

  picture {
    overflow: hidden;
    display: block;
    position: sticky;
    height: calc(var(--hh));
    top: calc(100vh - var(--hh));

    ::after {
      ${pseudoStyles}
      bottom: 0;
      background: rgb(var(--bot-color));
      mask-image: linear-gradient(transparent, black);
      -webkit-mask-image: linear-gradient(transparent, black);
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const FCaption = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  ${fullGrid};

  & figcaption.${isInnerCN} {
    ${fullWidthInnerStyle};
  }
`

/* customAlt is used in Establishment to make the alt automaticly filled with the Dealer infos */
export default function BannerPicture({ image_cld: image, meta, transition_gradient, fig_caption, customAlt }) {
  return (
    <Root style={{ zIndex: -1 - (meta ? meta.index : 0), "--bot-color": transition_gradient?.bottom_color }}>
      <Image {...image} alt={customAlt || image.alt} sizes='100vw' />
      {fig_caption?.caption?.length ? (
        <FCaption>
          <FigCaption {...fig_caption} />
        </FCaption>
      ) : null}
    </Root>
  )
}
